import { analyticsManager } from '@inpart-io/devtools-vue';
import { DefaultCategoryValues, LeadStatus } from '@inpart-io/padme-iap';
import { useQuasar } from 'quasar';
import { useStore } from 'vuex';

import LeadForm from '@/components/lead-form/lead-form.vue';
import { usePermissionHelper } from '@/composables/usePermissionHelper';
import { ANALYTICS_EVENTS } from '@/constants/analytics.constants';
import { ADD_SEARCH_RESULT, REFRESH_CURRENT_PAGE } from '@/store/base/search/actions';
import { LEAD_MODULE } from '@/store/lead-module';
import { INCREASE_LEAD_COUNT } from '@/store/lead-module/actions';
import { PRIVATE_LEAD_BOARD_MODULE } from '@/store/private-lead-board-module';
import { GET_DEFAULT_BOARD } from '@/store/private-lead-board-module/getters';

export interface ILeadCreationParams {
    briefId?: number;
    campaignId?: number;
    companyId?: number;
    conferenceId?: number;
    contactId?: number;
    internalContactId?: number;
    meetingId?: number;
}

export function useLeadCreationHelper(): {
    createLead: (params: ILeadCreationParams) => Promise<number[]>;
} {
    const store = useStore();
    const q = useQuasar();
    const { isManager } = usePermissionHelper();

    const createLead = async (params: ILeadCreationParams): Promise<number[]> => {
        analyticsManager.trackAction(ANALYTICS_EVENTS.LEAD_CREATION.CREATE_BUTTON, { originPage: window.location.href });
        return new Promise((resolve, reject) => {
            q.dialog({
                component: LeadForm,
                componentProps: {
                    fromInternalContactId: params.internalContactId,
                    fromContactId: params.contactId,
                    fromMeetingId: params.meetingId,
                    originFromCampaignId: params.campaignId,
                    originFromConferenceId: params.conferenceId,
                    preselectedBriefId: params.briefId,
                    preselectedCompanyId: params.companyId
                }
            })
                .onOk((idList: number[]) => {
                    try {
                        if (idList?.length) {
                            // to-do add to result list
                            void store.dispatch(`${LEAD_MODULE}/${REFRESH_CURRENT_PAGE}`);

                            const allId = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_DEFAULT_BOARD}`](DefaultCategoryValues.ALL)?.dobjId;
                            const myId = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_DEFAULT_BOARD}`](DefaultCategoryValues.MY)?.dobjId;

                            // Update homepage dashboards
                            const allLeadsKey = `dashboard-${allId}`;
                            void store.dispatch(`${LEAD_MODULE}/${INCREASE_LEAD_COUNT}`, {
                                status: LeadStatus.DRAFT,
                                count: idList.length,
                                key: allLeadsKey
                            });
                            void store.dispatch(`${LEAD_MODULE}/${ADD_SEARCH_RESULT}`, { key: allLeadsKey, idList });
                            if (isManager) {
                                const myLeadsKey = `dashboard-${myId}`;
                                void store.dispatch(`${LEAD_MODULE}/${INCREASE_LEAD_COUNT}`, {
                                    status: LeadStatus.DRAFT,
                                    count: idList.length,
                                    key: myLeadsKey
                                });
                                void store.dispatch(`${LEAD_MODULE}/${ADD_SEARCH_RESULT}`, { key: myLeadsKey, idList });
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    } finally {
                        resolve(idList);
                    }
                })
                .onCancel(() => {
                    reject(new Error());
                });
        });
    };

    return { createLead };
}
